import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import "../../assets/css/style.css";
import "../../assets/css/login.css"


const ForgotForm = () => {


    const handleSubmit = (e) => {
        e.preventDefault(); 
        const email = e.target.email.value;
        console.log("Password reset pour email:", email);
    };


    return (
        <section className="loginSection">
            <h1>Agileom</h1>
            <h4 className="interimH4">Intérim connecté</h4>


            <section className="formSection forgotFormSection">
                <form onSubmit={handleSubmit}>
                    <h4 className="forgotPassH4">Mot de passe oublié</h4>

                    <p className="instructionText">
                        Veuillez entrer votre adresse e-mail dans le champ ci-dessous
                        et suivre les instructions contenues dans l'email qui vous sera envoyé.
                    </p>

                    <div className="emailDiv">
                        <label htmlFor="email">E-mail</label>
                        <input type="email" id="email" name="email" required />
                    </div>

                    <button type="submit" className="btn btn-validate">Valider</button>

                </form>

                <a className="backLink">              
                    <Link className="nav-links" to="/login">
                          Retour
                    </Link>
                </a>

            </section>
        </section>
    );
}

export default ForgotForm;